import { ApolloError } from "@apollo/client";
import _ from "lodash";

export interface BackendError {
  type: string;
  message?: string;
  model?: string;
  keys?: string[];
}

export const parseError = (e: ApolloError) => {
  console.log("trying to decode error", e);
  try {
    const msg = e.message;
    const obj = JSON.parse(msg);
    console.log("got object", obj);
    if (_.get(obj, "type", null) !== null) {
      return obj as BackendError;
    }
  } catch (_e) {
    console.log("failed", _e);
  }
  return null;
};
